'use client';

import { Heading } from '@preventx/oxygen';

// Contexts
import { useProductDetailsContext } from '@/context/ProductDetailsProvider';

type PriceHeadingProps = {
  basePrice: string;
};

export const PriceHeading = ({ basePrice }: PriceHeadingProps) => {
  const { selectedProduct } = useProductDetailsContext();

  let price: string = basePrice;

  if (selectedProduct) {
    price = selectedProduct.price.toString();
  }

  return (
    <Heading component="h2" className="mt-2">
      {price}
    </Heading>
  );
};
